module.exports = __webpack_public_path__ + "static/media/pin.cdfd2ee0.svg";